export const VERSION_PLACEHOLDER = '{version}';

// countryCode, address.countryCode and languageCode are temporarily hardcoded.
// Their values should be taken from the country language switcher or a browser.
export const INITIAL_QUESTION_FLOW_PROJECT_DATA = {
    projectName: 'HSP Project v0.1',
    countryCode: 'DE', // temporary hardcode
    address: { countryCode: 'DE' }, // temporary hardcode
    languageCode: 'de', // temporary hardcode
    currencyCode: 'EUR',
    building: {
        heatLoadCalculations: [
            {
                // temporary hardcode. Setting heat load calculation requires backend support, which is not ready yet.
                isSelected: true,
                method: 'LIVING_SPACE'
            }
        ]
    }
};
